import React from 'react';
import auth from './auth';
import { useHistory } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import { unregister } from '../serviceWorkerRegistration';

export const LogoutComponent = (props) => {
  const history = useHistory();

  const logout = () => {
    auth.logout(() => {
      // ClevertapReact.logout();
      unregister();
      localStorage.clear();
      history.push('/login');
    });
  }

  return (
    <span>
      {
        props.mobileView ?
          <MenuItem className="w-full text-xs" sx={{justifyContent: "flex-start !important"}} onClick={logout}>
            <IconButton
              size="large"
              edge="end"
              aria-label="Sign Out"
              color="inherit"
            >
              <ExitToAppIcon className="w-6" />
            </IconButton>
            <p className="pl-3 text-sm">Sign Out</p>
          </MenuItem>
          :
          <IconButton
            size="large"
            edge="end"
            aria-label="Sign Out"
            onClick={logout}
            color="inherit"
          >
            <Avatar className="uppercase text-center" sx={{ width: 30, height: 30, fontSize:'15px', bgcolor: '#F8F8F8' }}>
                <ExitToAppIcon className="text-black" />
            </Avatar>
          </IconButton>
      }
    </span>


  );

};